<div
    [id]="id + '.' + filter.id"
    class="agpr-filterCheckboxes"
>
    <div class="agpr-filterCheckboxes-toggleContainer">
        <agpr-button
            [id]="id + '.' + filter.id + (anyOptionsSelected ? '.selectNone' : '.selectAll')"
            class="agpr-filterCheckboxes-allToggle"
            [style]="buttonTypes.link"
            (click)="selectItems()"
            [label]="(anyOptionsSelected ? 'selectNone' : 'selectAll') | localize"
            aria-live="polite"
        >
        </agpr-button>
    </div>
    <agpr-scroll-panel>
        <ul
            class="agpr-filterCheckboxes-list"
            [attr.aria-label]="'filter' | localize"
        >
            <li
                *ngFor="let option of filteredOptions; let i = index"
                class="agpr-filterCheckboxes-item"
            >
                <agpr-checkbox
                    [id]="id + '_' + filter.id + '_checkbox_' + i"
                    [name]="'filterCheckboxes-' + filter.id"
                    [value]="option.value"
                    [label]="option.label"
                    [infoCircleTooltip]="!option.value.isProvisioned ? ('MediaTypeCheckbox.notProvisionedIconToolTip' | localize: {mediaType: option.label}) : null"
                    [disabled]="!option.value.isProvisioned"
                    [(ngModel)]="value"
                    (ngModelChange)="handleChange()"
                >
                </agpr-checkbox>
            </li>
        </ul>
    </agpr-scroll-panel>
</div>
